import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { useI18n } from "../../lib/i18n";

const ChannelTag = ({ channels, channelId }) => {
  const ch = channels.find(c => c.id === channelId);
  if (!ch) return null;
  return (
    <div className="text-xs text-[color:var(--text-muted)] flex items-center gap-2">
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: ch.color }} />
      {ch.name}
    </div>
  );
};

export const TrendingSection = ({ videos, channels }) => {
  const { t } = useI18n();
  return (
    <section className="max-w-[1400px] mx-auto px-6 py-12">
      <div className="flex items-center gap-3 mb-6">
        <TrendingUp className="w-5 h-5 text-[color:var(--accent)]" />
        <h2 className="font-display text-3xl">{t("home.trending")}</h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 stagger" data-testid="trending-grid">
        {videos.slice(0, 8).map(v => (
          <Link to={`/watch/${v.id}`} key={v.id} className="card-hover rounded-xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--bg-elev)]" data-testid={`video-card-${v.id}`}>
            <div className="aspect-video bg-black relative">
              {v.thumbnail && <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute top-2 left-2 px-2 py-0.5 bg-[color:var(--accent)] text-white text-[10px] uppercase tracking-wider rounded">
                {v.source_type === "youtube" ? "YT" : "HD"}
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-medium line-clamp-2 mb-1">{v.title}</h3>
              <ChannelTag channels={channels} channelId={v.channel_id} />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export const ChannelGridSection = ({ channels }) => (
  <section className="max-w-[1400px] mx-auto px-6 py-12">
    <h2 className="font-display text-3xl mb-6">Toutes les chaînes</h2>
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 stagger">
      {channels.map(c => (
        <Link key={c.id} to={`/channel/${c.id}`} className="card-hover rounded-xl p-5 border border-[color:var(--border)] bg-[color:var(--bg-elev)] block" data-testid={`channel-tile-${c.id}`}>
          <div className="w-12 h-12 rounded-lg mb-4" style={{ background: c.color }} />
          <div className="font-display text-xl">{c.name}</div>
          <div className="text-xs uppercase tracking-wider text-[color:var(--text-muted)]">{c.category}</div>
        </Link>
      ))}
    </div>
  </section>
);
